import { FC } from 'react';
import { HStack, Text, Button, Spinner } from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';
import { useVersionStore } from '@/stores/versionStore';

/**
 * バージョン表示バッジコンポーネント
 * - 現在のバージョンを表示
 * - アップデートボタンを常時表示（キャッシュクリア + リロードで強制更新）
 */
export const VersionBadge: FC = () => {
  const { currentVersion, isUpdateAvailable, isChecking, performUpdate } =
    useVersionStore();

  const handleUpdate = () => {
    performUpdate();
  };

  return (
    <HStack gap={1} align="center">
      <Text
        fontSize="xs"
        color={isUpdateAvailable ? 'orange.600' : 'gray.500'}
        fontWeight="medium"
        bg={isUpdateAvailable ? 'orange.50' : 'gray.100'}
        px={2}
        py={0.5}
        borderRadius="md"
      >
        v{currentVersion}
      </Text>

      {isChecking && <Spinner size="xs" color="gray.400" />}

      <Button
        size="2xs"
        variant={isUpdateAvailable ? 'solid' : 'outline'}
        colorPalette={isUpdateAvailable ? 'orange' : 'gray'}
        onClick={handleUpdate}
      >
        <FiRefreshCw size={12} />
        アップデート
      </Button>
    </HStack>
  );
};
